import React, { useMemo, useState } from "react";
import { Box, MainText } from "app/components/common";
import normalize from "app/utils/normalize";
import Step from "./Step";

interface Props {
  numberOfSteps: number;
  totalDone: number;
  spaceBetweenSteps?: number;
  stepHeight?: number;
}

const SteppedProgressBar = ({
  numberOfSteps,
  totalDone,
  spaceBetweenSteps = normalize(2),
  stepHeight = 4,
}: Props) => {
  const [width, setWidth] = useState(100);

  const findDimensions = ({ height, width }) => {
    setWidth(width);
  };

  const handleOnLayout = event => {
    findDimensions(event.nativeEvent.layout);
  };

  const array = useMemo(() => [...new Array(numberOfSteps)], [numberOfSteps]);

  return (
    <Box
      onLayout={handleOnLayout}
      justifyContent="space-between"
      flexDirection="row"
    >
      {array.map((el, i) => {
        return (
          <Step
            height={stepHeight}
            key={i}
            width={width / numberOfSteps - spaceBetweenSteps}
            color={i < totalDone ? "brand.500" : "neutral.100"}
          />
        );
      })}
    </Box>
  );
};

export { SteppedProgressBar };
